<p-steps
  [model]="steps"
  [activeIndex]="activeStep"></p-steps>

@if ((loading$ | async) === false) {
  @if (!activeStep) {
    <p-card styleClass="mt-3">
      <div class="p-fluid">
        <div class="field">
          <label class="font-medium">Период</label>
          <crm-daterangepicker
            [value]="[contractQueryParams.from, contractQueryParams.to]"
            (changeValue)="setDateFilters($event)"
            appendTo="body"></crm-daterangepicker>
        </div>

        <div class="field">
          <label class="font-medium">Реквизиты</label>
          <crm-multi-select
            [options]="contractAnalyticalFeatures"
            [(selectedItems)]="contractQueryParams.features"
            [showHeader]="false"
            display=""
            optionValue="name"
            appendTo="body">
            <ng-template
              #selectedItemsTemplate
              let-items="items">
              @for (item of items; track item.id; let isLast = $last) {
                {{ item?.value | contractAnalyticalFeatureName }}{{ isLast ? '' : ', ' }}
              }
            </ng-template>
            <ng-template
              #itemTemplate
              let-item="item">
              <div>
                <p>{{ item?.value | contractAnalyticalFeatureName }}</p>
              </div>
            </ng-template>
          </crm-multi-select>
        </div>

        <div class="field">
          <label class="font-medium">Компания</label>
          <crm-company-multi-select
            [(selectedCompanies)]="selectedCompanies"
            [isFloatLabel]="false"
            appendTo="body"></crm-company-multi-select>
        </div>

        <div class="field">
          <label class="font-medium">Контрагент</label>
          <crm-contragent-multi-select
            [(selectedEntities)]="selectedContragents"
            appendTo="body"></crm-contragent-multi-select>
        </div>

        <div class="field-checkbox">
          <p-checkbox
            [(ngModel)]="contractQueryParams.replaceCurrent"
            [binary]="true"
            inputId="replaceCurrent"></p-checkbox>
          <label [for]="'replaceCurrent'">Заменять текущие реквизиты в договоре</label>
        </div>
      </div>
    </p-card>

    <div class="mt-3 flex justify-content-end">
      <crm-button
        label="Далее"
        icon="pi pi-arrow-right"
        styleClass="p-button-success"
        (onClick)="changeStep()"></crm-button>
    </div>
  } @else if (activeStep === 1) {
    <p-card styleClass="mt-3">
      @if (items?.length) {
        <p-messages severity="info">
          <ng-template pTemplate="">
            <div class="flex gap-2 align-items-center">
              <i
                class="pi pi-exclamation-circle"
                style="font-size: 1.3rem"></i>
              <p class="text-lg">
                Найдена аналитика из связанных с договором утвержденных заявок на платеж. Вы действительно хотите
                заполнить эту аналитику в договоры с последующей выгрузкой в 1С?
              </p>
            </div>
          </ng-template>
        </p-messages>
      }
      <div class="max-h-29rem overflow-y-auto overflow-x-hidden mt-3">
        <crm-table
          [columns]="columns"
          [values]="items">
          <ng-template
            #rowTemplate
            let-item="item">
            @if (toItem(item); as item) {
              <tr>
                <td>
                  <a class="white-space-nowrap" crmConditionalRouterLink [crmRouterLink]="['/client/contract/card/', item.id]">
                    {{ item.name }}
                  </a>
                </td>
                @for (
                  feature of contractQueryParams.features?.length
                    ? contractQueryParams.features
                    : contractAnalyticalFeatures;
                  track feature
                ) {
                  <td>
                    @if (feature === ContractAnalyticalFeatureEnum.DIRECTION) {
                      @if (item.oldDirection?.id === item.direction?.id) {
                        {{ item.direction?.name }}
                      } @else {
                        @if (item.oldDirection) {
                          <span class="line-through">{{ item.oldDirection?.name }} </span>
                        }
                        <span class="text-green-400 font-bold">
                          {{ item.direction?.name }}
                        </span>
                      }
                    } @else if (feature === ContractAnalyticalFeatureEnum.UNIT) {
                      @if (item.oldUnit?.id === item.unit?.id) {
                        {{ item.unit?.name }}
                      } @else {
                        @if (item.oldUnit) {
                          <span class="line-through">{{ item.oldUnit?.name }} </span>
                        }
                        <span class="text-green-400 font-bold">
                          {{ item.unit?.name }}
                        </span>
                      }
                    } @else if (feature === ContractAnalyticalFeatureEnum.FILIAL) {
                      @if (item.oldFilial?.id === item.filial?.id) {
                        {{ item.filial?.name }}
                      } @else {
                        @if (item.oldFilial) {
                          <span class="line-through">{{ item.oldFilial?.name }} </span>
                        }
                        <span class="text-green-400 font-bold">
                          {{ item.filial?.name }}
                        </span>
                      }
                    } @else if (feature === ContractAnalyticalFeatureEnum.COST_CENTER) {
                      @if (item.oldCostCenter?.id === item.costCenter?.id) {
                        {{ item.costCenter?.name }}
                      } @else {
                        @if (item.oldCostCenter) {
                          <span class="line-through">{{ item.oldCostCenter?.name }} </span>
                        }
                        <span class="text-green-400 font-bold">
                          {{ item.costCenter?.name }}
                        </span>
                      }
                    } @else if (feature === ContractAnalyticalFeatureEnum.DEAL) {
                      @if (item.oldDeal?.id === item.deal?.id) {
                        {{ item.deal?.name }}
                      } @else {
                        @if (item.oldDeal) {
                          <span class="line-through">{{ item.oldDeal?.name }} </span>
                        }
                        <span class="text-green-400 font-bold">
                          {{ item.deal?.name }}
                        </span>
                      }
                    }
                  </td>
                }
              </tr>
            }
          </ng-template>
        </crm-table>
      </div>
    </p-card>

    <div class="mt-3 flex align-items-center gap-3">
      <crm-button
        label="Назад"
        icon="pi pi-arrow-left"
        styleClass="p-button-secondary p-button-text"
        (onClick)="activeStep = 0"></crm-button>
      <crm-button
        label="Сохранить"
        styleClass="p-button-success"
        (onClick)="create()"></crm-button>
    </div>
  }
} @else {
  <crm-spinner></crm-spinner>
}
